import { BrandConfig } from '../types';

export const jogoglobal2Config: BrandConfig = {
  id: 'jogoglobal2',
  name: 'Jogo Global 2',
  displayName: 'Jogo Global 2',
  logo: 'JG-logo.png',
  primaryColor: '#4aa4fc',
  categories: [
    {
      name: 'Jogo Games',
      banner: 'banners/banner_JG.png',
      gamesPath: 'jogoglobal2/jogoGames/jogoGames.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Estrela Bet',
      banner: 'banners/banner_estrelabet.png',
      gamesPath: 'jogoglobal2/estrelaBet/estrelaBet.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Betfred',
      banner: 'banners/banner_betfred.png',
      gamesPath: 'brands/betfred.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    }
  ],
  defaultBanners: []
};
